// MUST be first: installs OS-keychain interception for Supabase auth token
// in the Electron desktop app. No-op in normal browsers.
import "./lib/electron-secure-storage-shim";
import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@fontsource/plus-jakarta-sans/400.css";
import "@fontsource/plus-jakarta-sans/500.css";
import "@fontsource/plus-jakarta-sans/600.css";
import "@fontsource/plus-jakarta-sans/700.css";
import "@fontsource/plus-jakarta-sans/800.css";
import App from "./App.tsx";
import "./index.css";
import { registerPwa } from "./pwa/register-sw";
import { installOutboxAutoSync, drainOutbox } from "./lib/prescription-outbox";
import { initOfflineOutbox } from "./lib/offline-outbox";
import { initUploadOutbox } from "./lib/upload-outbox";
import { initDocShareOutbox } from "./lib/offline-doc";
import { toast } from "sonner";

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

registerPwa();

// Drain any queued prescriptions when we boot online / reconnect / return to tab.
installOutboxAutoSync((r) => {
  if (r.synced > 0) {
    toast.success(
      `Synced ${r.synced} offline prescription${r.synced === 1 ? "" : "s"}`,
    );
  }
});
// Also drain once at startup in case we came back online after a long offline session.
void drainOutbox();

// App-wide offline write outbox (patients, notes, invoices, tasks, ...).
initOfflineOutbox((r) => {
  toast.success(`Synced ${r.synced} offline change${r.synced === 1 ? "" : "s"}`);
});

// Queued document/file uploads (stored as blobs in IndexedDB while offline).
initUploadOutbox((r) => {
  toast.success(`Uploaded ${r.synced} offline file${r.synced === 1 ? "" : "s"}`);
});

// Invoices / prescriptions exported offline that still need to be shared.
initDocShareOutbox((count) => {
  toast.info(`${count} document${count === 1 ? "" : "s"} ready to send · পাঠানোর অপেক্ষায়`);
});

